'use strict';

export default function routes($stateProvider) {
  'ngInject';
  $stateProvider.state('utilisateurs', {
    url: '/utilisateurs',
    template: '<utilisateurs></utilisateurs>',
    authenticate: true
  });
}



// WEBPACK FOOTER //
// ./client/app/utilisateurs/utilisateurs.routes.js